import React, { useCallback, useContext }  from 'react';
import { withRouter, Redirect } from 'react-router';
import { isEmpty } from 'check-tool';

import { getLanguage } from 'common/i18n';

import MenuTop from 'components/MenuTop';
import MenuLeft from 'components/MenuLeft';
import { AuthContext } from 'AuthProvider';

const LandingPage = () => {
  const lang = getLanguage();
  const { currentUser } = useContext(AuthContext);

  if (isEmpty(currentUser)) {
    return <Redirect to="/signin" />;
  }

  return (
    <div>
      <MenuTop lang={lang} user={currentUser} />
      <div className="main-container ace-save-state" id="main-container">
        <MenuLeft lang={lang} user={currentUser} currentPage="landing" />
        <div className="main-content">
          <div className="main-content-inner">
            <div className="page-content">
              <div className="row">
							  <div className="col-xs-12">
                  Landing info
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
